module.exports = __webpack_public_path__ + "img/00050.bf40f7c8.webp";